import React from "react";

export interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void | Promise<void>;
    label?: string;
    disabled?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, label, disabled }) => {
    const id = React.useId();

    return (
        <label
            htmlFor={id}
            className={`relative inline-flex items-center ${
                disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
            }`}
        >
            {label && <span className="text-sm font-medium text-ink mr-2">{label}</span>}
            <input
                id={id}
                type="checkbox"
                checked={checked}
                onChange={(e) => !disabled && onChange(e.target.checked)}
                disabled={disabled}
                className="sr-only peer"
            />
            <div
                className={`w-10 h-[22px] rounded-full duration-200 ring-0 relative transition-colors
                    ${checked ? "bg-primary" : "bg-surface-sunken border border-border"}
                    after:absolute after:top-0.5 after:left-0.5 after:bg-white
                    after:rounded-full after:h-[18px] after:w-[18px] after:shadow-sm
                    after:transition-transform after:duration-200
                    ${checked ? "after:translate-x-[18px]" : ""}
                `}
            />
        </label>
    );
};
